import ShoppingBagCheckmarkCircle from '../../src/legacy/ShoppingBagCheckmarkCircle';
export default ShoppingBagCheckmarkCircle;
